<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.complianceincident" :id="id" :models="models" :infos="infos" topClass=""></show>

			<!-- Gestione incidente -->
			<v-card v-if="incident" class="background-2 round-card mt-4">
				<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Gestione incidente</p></v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<div class="d-flex align-center flex-wrap">
						<span class="mr-3">Stato attuale:</span>
						<v-chip :color="statusMeta(incident.status).color" dark label class="mr-4">
							<v-icon left small>{{ statusMeta(incident.status).icon }}</v-icon>
							{{ statusMeta(incident.status).text }}
						</v-chip>
						<v-spacer></v-spacer>
						<v-btn v-for="t in incident.available_transitions" :key="t" small class="ml-2 mb-1"
							:color="statusMeta(t).color" dark @click="transition(t)">
							<v-icon left small>{{ statusMeta(t).icon }}</v-icon>
							{{ statusMeta(t).text }}
						</v-btn>
					</div>
					<p v-if="incident.reported_to_authority" class="mt-3 mb-0 deep-orange--text">
						<v-icon small color="deep-orange">mdi-bank</v-icon> Notificato al Garante{{ incident.reported_at ? ' il ' + incident.reported_at : '' }}
					</p>
					<div class="mt-3">
						<v-btn v-if="incident.nonconformity_id" text small color="success"
							@click="$router.push({ name: 'compliancenonconformities-show', params: { id: incident.nonconformity_id } })">
							<v-icon small left>mdi-link-variant</v-icon> NC collegata #{{ incident.nonconformity_id }}
						</v-btn>
						<v-btn v-else text small color="error" :loading="ncLoading" @click="generateNc">
							<v-icon small left>mdi-alert-octagon</v-icon> Genera Non Conformità
						</v-btn>
					</div>
				</v-card-text>
			</v-card>

			<!-- Norme -->
			<v-card v-if="incident" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openNorms"><v-icon left small>mdi-pencil</v-icon> Modifica</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<template v-if="incident.norms && incident.norms.length">
						<v-chip v-for="n in incident.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>{{ n.text }}</v-chip>
					</template>
					<span v-else class="grey--text">— nessuna —</span>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="complianceincident"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'complianceincidents-edit', id)" color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<v-dialog v-model="normsDialog" max-width="560" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Norme applicabili</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="formNorms" :items="normOptions" item-text="text" item-value="value"
							label="Norme" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-certificate"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="normsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="savingNorms" @click="saveNorms">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceIncident',
	props: { id: Number },
	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			ncLoading: false,
			normsDialog: false,
			savingNorms: false,
			formNorms: [],
			normOptions: [],
			statusMap: {
				aperto:      { text: 'Aperto',      color: '#f44336', icon: 'mdi-folder-open' },
				in_gestione: { text: 'In gestione', color: '#ff9800', icon: 'mdi-progress-wrench' },
				contenuto:   { text: 'Contenuto',   color: '#2196f3', icon: 'mdi-shield-check' },
				risolto:     { text: 'Risolto',     color: '#03a9f4', icon: 'mdi-check-decagram' },
				chiuso:      { text: 'Chiuso',      color: '#4caf50', icon: 'mdi-folder-check' }
			}
		}
	},
	computed: {
		incident() { return this.models.complianceincident }
	},
	created() { this.load() },
	methods: {
		load() {
			this.loading = true
			this.axios.get('complianceincidents/' + this.id).then(r => {
				this.models = r.data.models
				this.infos = r.data.infos
				this.loading = false
			}, () => { this.loading = false; this.$store.commit('setSnackbarError') })
		},
		statusMeta(s) { return this.statusMap[s] || { text: s, color: 'grey', icon: 'mdi-help-circle' } },
		transition(target) {
			this.axios.post('complianceincidents/' + this.id + '/transition', { status: target }).then(() => {
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Stato aggiornato', timeout: 4000 })
				this.load()
			}, error => {
				const msg = error.response && error.response.data ? error.response.data.message : 'Errore nel cambio di stato'
				this.$store.commit('setSnackbar', { value: true, color: 'error', text: msg, timeout: 6000 })
			})
		},
		generateNc() {
			this.ncLoading = true
			this.axios.post('complianceincidents/' + this.id + '/generate-nc').then(() => {
				this.ncLoading = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Non conformità generata', timeout: 4000 })
				this.load()
			}, error => {
				this.ncLoading = false
				const msg = error.response && error.response.data ? error.response.data.message : 'Errore'
				this.$store.commit('setSnackbar', { value: true, color: 'error', text: msg, timeout: 6000 })
			})
		},
		openNorms() {
			this.formNorms = (this.incident.norms || []).map(n => n.value)
			if (!this.normOptions.length) this.axios.get('compliance-norms-options').then(r => { this.normOptions = r.data.data })
			this.normsDialog = true
		},
		saveNorms() {
			this.savingNorms = true
			this.axios.put('complianceincidents/' + this.id, { norms: this.formNorms }).then(() => {
				this.savingNorms = false; this.normsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => { this.savingNorms = false; this.$store.commit('setSnackbarError') })
		}
	}
}
</script>
